import useAsyncData from 'src/utils/useAsyncData';
import { getOrganizationUsersAPI } from 'src/serverApi/organizationUsers';

const useOrganizationUsers = () => {
  const [
    fetchOrganizationUsers,
    wasOrganizationUsersFetched,
    isOrganizationUsersLoading,
    organizationUsers,
    organizationUsersError,
  ] = useAsyncData(getOrganizationUsersAPI);

  return {
    fetchOrganizationUsers,
    wasOrganizationUsersFetched,
    isOrganizationUsersLoading,
    organizationUsers,
    organizationUsersError,
  };
};

export default useOrganizationUsers;
